import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '@/lib/axios';
import { usersFavoriteCleanersQueryKey } from '@/hooks/queries/use-get-users-favorite-cleaners-list.query';

interface FavoriteCleanerPayload {
  cleaner_id: string;
}

interface FavoriteCleanerResponse {
  success: boolean;
  message?: string;
}

const postUsersFavoriteCleaners = async (
  payload: FavoriteCleanerPayload
): Promise<FavoriteCleanerResponse> => {
  const response = await axios.post('/users/favorite-cleaners/', payload);
  return response.data;
};

export const usePostUsersFavoriteCleanersMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: postUsersFavoriteCleaners,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: usersFavoriteCleanersQueryKey,
      });
    },
  });
};
